export function getCurrentQueryParameters() {
    let params = {};
    try {
        let queryStr = decodeURIComponent(window.location.search.replace('?',''));
        if (queryStr && queryStr.length > 0) {
            let query = queryStr.split('&');
            query.map((row)=>{
                let r = row.split("=");
                params[r[0]] = r[1];
            })
        }
    } catch(e) {
        console.error(e);
    }
    return params;
}